import { FC } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircleIcon from '@mui/icons-material/Circle';
import Avatar from '@mui/material/Avatar';
import cindyChatAvatar from '/public/img/ai/cindy-chat-avatar.png';

const getCircleIconSx = (index) => ({
  color: '#C7DFFF',
  width: 16,
  height: 16,
  ml: 0.5,
  opacity: 0,
  animation: `fadeIn 1.5s ease-in-out ${index * 0.2}s infinite`,
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
    },
    '50%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0,
    },
  },
});

export const PendingMessage: FC = (): JSX.Element => {
  return (
    <Box display='flex'>
      <Box display='flex' alignItems='start'>
        <Avatar
          alt='Cindy'
          src={cindyChatAvatar.src}
          sx={{ width: 52, height: 52, mr: 1 }}
        />
      </Box>
      <Box display='flex' flexDirection='column' mb={2}>
        <Typography variant='subtitle1' fontWeight={'bold'}>
          Cindy
        </Typography>
        <Box
          sx={{
            backgroundColor: '#F1F7FF',
            borderRadius: '0px 10px 10px 10px',
            color: '#000',
            p: 1,
          }}
        >
          {[...Array(3)].map((_, index) => (
            <CircleIcon
              key={`circleIcon-${index}`}
              sx={getCircleIconSx(index)}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};
